// @flow

import includes from 'lodash/includes';
import isPageLoadedInsideIframe from './isPageLoadedInsideIframe';

export type OperatingSystem = 'iOS' | 'Android' | 'Windows' | 'Macintosh' | 'Linux' | 'Unknown';
export type SDKType = 'Web' | 'iOS' | 'Android';
export type Gender = 'male' | 'female' | 'nb' | 'unknown';


export type Targeting = {
    allowedOperatingSystems?: OperatingSystem[],
    allowedSDKTypes?: SDKType[],
    allowedGenders?: Gender[],
    minAge?: number,
    maxAge?: number,
}


export type UserData = {
    gender?: Gender,
    age?: number,
    name?: string, // user's real name
    userId?: string,  // unique ID that identifies the user inside the publisher's app
    facebookUserId?: string,
};


function currentSDKType(): SDKType {
    if (isPageLoadedInsideIframe()) {
        return 'Web';
    }
    const os = operatingSystemFromUserAgent();
    switch (os) {
        case 'Android': return 'Android';
        case 'iOS': return 'iOS';
        default: return 'Web';
    }
}


function operatingSystemFromUserAgent(): OperatingSystem {
  const ua = window.navigator.userAgent;
  if (ua.match(/Windows/)) {
    return 'Windows';
  } else if (ua.match(/iPhone/ || ua.match(/iPad/))) {
    return 'iOS';
  } else if (ua.match(/Macintosh/)) {
    return 'Macintosh';
  } else if (ua.match(/Android/)) {
    return 'Android';
  } else if (ua.match(/Linux/)) {
    return 'Linux';
  }
  return 'Unknown';
}


function isMatchingSDKType(targeting: Targeting) {
    if (!targeting.allowedSDKTypes) return true;
    return includes(targeting.allowedSDKTypes, currentSDKType());
}


function isMatchingAge(userData: UserData, targeting: Targeting) {
    if (typeof targeting.minAge !== 'number') {
        return true;
    }

    if (typeof targeting.maxAge !== 'number') {
        return true;
    }

    if (targeting.minAge < 0) return false;
    if (targeting.maxAge < targeting.minAge) return false;

    return !userData.age ? false : (targeting.minAge <= userData.age && targeting.maxAge >= userData.age);
}


function isMatchingGender(userData: UserData, targeting: Targeting) {
    if (!targeting.allowedGenders) return true;
    const allowedGenders = targeting.allowedGenders.map(s => s.toLowerCase());
    if (includes(allowedGenders, 'unknown')) return true;
    const userGender = (userData && userData.gender && userData.gender.toLowerCase()) || 'unknown';
    return includes(allowedGenders, userGender);
}


function isMatchingOperatingSystem(targeting: Targeting) {
    if (!targeting.allowedOperatingSystems) return true;
    return includes(targeting.allowedOperatingSystems, operatingSystemFromUserAgent());
}


export function isMatchingTargeting(userData: UserData, targeting: Targeting) {
    if (!userData || !targeting) return true;
    return isMatchingSDKType(targeting) &&
        isMatchingOperatingSystem(targeting) &&
        isMatchingAge(userData, targeting) &&
        isMatchingGender(userData, targeting);
}



// WEBPACK FOOTER //
// ./src/lib/Targeting.js